import "./Block19PaidFieldsTable.css";

import { CircularProgress, useTheme } from "@mui/material";
import { FC, useEffect, useState } from "react";

import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { EnhancedButtonPrimeReact, EnhancedButtonPrimeReactSeverity, EnhancedRadioGroupRHF } from "@websential/cosmic-v20";
import { Block17BSetupFieldsPanelHeader } from "../Block17BSetupFieldsPanelTable/Block17BSetupFieldPanelHeader";

let Block19PaidFieldsDDLData = [
  { label: "--", value: null },
  {
    label: "Paid sick leave (EI Insurable)",
    value: "PSL01",
  },
  {
    label: "Wage loss indemnity (Not EI insurable)",
    value: "WLI01",
  },
  {
    label: "Wage loss indemnity (EI Insurable)",
    value: "WLI02",
  },
  {
    label:
      "Paid Maternity/Parental/Compassionate Care/Family Caregiver leave (EI Insurable)",
    value: "MAT01",
  },
];


let Block19PaidPaymentPeriodDDL = [
   { label: "--", value: null },
  {
    label: "Per Day",
    value: "100",
  },
  {
    label: "Per Week",
    value: "200",
  },
];

let columns = [
  { field: "paymentType" },
  { field: "paymentStartDate" },
  { field: "paymentEndDate" },
  { field: "paymentAmount" },
  { field: "paymentPeriod" },
];

let emptyBlock19PaidFields = {
  id: null,
  paymentType: null,
  paymentStartDate: null,
  paymentEndDate: null,
  paymentAmount: null,
  paymentPeriod: null,
}

interface IBlock19PaidFieldsTableData {
  block19PaidFieldsTableUpdatedData: (data: any) => void;
  block19PaidFieldsDataItems: any;
}
export const Block19PaidFieldsTableData: FC<
  IBlock19PaidFieldsTableData
> = ({ block19PaidFieldsTableUpdatedData, block19PaidFieldsDataItems }) => {

  const [block19PaidFieldsTable, setBlock19PaidFieldsTable] = useState<any>(
    block19PaidFieldsDataItems
  );

  const [lastAddedRowId, setLastAddedRowId] = useState<any>(null);
  const [block19PaidFieldsEmpty, setBlock19PaidFieldsEmpty] = useState(emptyBlock19PaidFields);

  useEffect(() => {
    block19PaidFieldsTableUpdatedData(block19PaidFieldsTable);
  }, [block19PaidFieldsTable]);

  useEffect(() => {
    setBlock19PaidFieldsTable(block19PaidFieldsDataItems);
  }, [block19PaidFieldsDataItems]);

  const findIndexById = (id: string | number | any) => {
    let index = -1;

    for (let i = 0; i < block19PaidFieldsTable.length; i++) {
      if (block19PaidFieldsTable[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return id;
  };

  const openNew = () => {
  

    if (block19PaidFieldsTable && block19PaidFieldsTable.length >= 4) return null;

    let _block17BSetupPanelData = [...block19PaidFieldsTable];
    let _block17BSetupPanelNewRow: any = { ...block19PaidFieldsEmpty };

    if (block19PaidFieldsEmpty.id) {
      const rowIndex = findIndexById(block19PaidFieldsEmpty.id);
      _block17BSetupPanelData[rowIndex] = _block17BSetupPanelNewRow;
      
    } else {
      const newRowId = createId();
      _block17BSetupPanelNewRow.id = newRowId;
      _block17BSetupPanelData.push(_block17BSetupPanelNewRow);
      setLastAddedRowId(newRowId && newRowId);
   
    }
    setBlock19PaidFieldsTable(_block17BSetupPanelData);
    setBlock19PaidFieldsEmpty(emptyBlock19PaidFields);
  };


  const onCellValueChange = (event: any, rowIndex: number, field: any) => {

    setBlock19PaidFieldsTable((prev: any) => {
      const updatedData = [...prev];

      const updatedRow = { ...updatedData[rowIndex], [event.field]: field };

      updatedData[rowIndex] = updatedRow; // ✅ Replace with new object (triggers re-render)
      return updatedData;
    });
  };

  const onDeleteNewAddedRow = (rowId: any) => {
    setBlock19PaidFieldsTable((prev: any[]) => {
      const rowDeleteBasedOnId = prev.filter((row) => row.id !== rowId);

      if (rowDeleteBasedOnId.length > 1) {
        const lastRowId = rowDeleteBasedOnId[rowDeleteBasedOnId.length - 1].id;
        setLastAddedRowId(lastRowId);
      } else {
        setLastAddedRowId(null);
      }
      return rowDeleteBasedOnId;
    });
  }

  const renderErrorClass = (field: any, rowIndex: number, rowData: any) => {
    if (field.field === "paymentStartDate") {
      if (
        rowData.block19PaidFields !== "" &&
        rowData.block19PaidFields !== undefined &&
        rowData.block19PaidFields !== null
      ) {
        if (rowData.paymentStartDate === null) {
          return "p-component p-filled calender-error-input";
        } else if (rowData.paymentStartDate === "") {
          return "p-component p-filled calender-error-input";
        }
      }
    } else if (field.field === "block19PaidFields") {
      if (
        rowData.paymentStartDate !== "" &&
        rowData.paymentStartDate !== undefined &&
        rowData.paymentStartDate !== null
      ) {
        if (rowData.block19PaidFields === null) {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        } else if (rowData.block19PaidFields === "") {
          return "p-component p-filled input-dropdown-fields .p-dropdown dropdown-error-input";
        }
      } else {
        return "p-component p-filled input-dropdown-fields .p-dropdown";
      }
    } else {
      return "p-component p-filled input-dropdown-fields";
    }
  };

  const columnsBody = (rowData: any, row: any, x: any) => {
    if (x.field === "paymentType") {
      return (
        <Dropdown
          options={Block19PaidFieldsDDLData}
          value={rowData[x.field]}
          onChange={(e: any) =>
            onCellValueChange(x, row.rowIndex, e.target.value)
          }
          placeholder="--"
          className={renderErrorClass(x, row.rowIndex, rowData)}
          optionLabel="label"
          optionValue="value"
          style={{ borderRadius: "2px", width: "300px" }}
        />
      );
    } else if (x.field === "paymentStartDate") {
      return (
        <Calendar
          id="paymentStartDate"
          value={rowData[x.field]}
          showIcon
          // className="calender"
          style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          dateFormat="M dd, yy"
          showButtonBar
          className={`calender ${renderErrorClass(x, row.rowIndex, rowData)}`}
        />
      );
    } else if (x.field === "paymentEndDate") {
      return (
        <Calendar
          id="paymentEndDate"
          value={rowData[x.field]}
          showIcon
          className="calender"
          style={{ height: "2.6rem", margin: "8px 0px 4px 0px", width: "auto" }}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          dateFormat="M dd, yy"
          showButtonBar
        />
      );
    } else if (x.field === "paymentPeriod") {
      return (
        <>
          {/* <Checkbox
            inputId="paymentPeriod"  // add DDL Later 
            name="paymentPeriod"
            value={rowData[x.field]}
            onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.checked)}
            checked={rowData[x.field]}
          />
          <label htmlFor="paymentPeriod" className="ml-2">
            Add to block 15B/15C
          </label> */}

          <Dropdown
            options={Block19PaidPaymentPeriodDDL}
            value={rowData[x.field]}
            onChange={(e: any) =>
              onCellValueChange(x, row.rowIndex, e.target.value)
            }
            placeholder="--"
            className={renderErrorClass(x, row.rowIndex, rowData)}
            optionLabel="label"
            optionValue="value"
            style={{ borderRadius: "2px", width: "150px" }}
          />
          {/* <EnhancedRadioGroupRHF
                                  name="paymentPeriod"
                                  key="paymentPeriod"
                                  testId="paymentPeriod"
                                  selectedValue="paymentPeriod"
                                  options={[
                                    {
                                      label: "Per Day",
                                      value: 100,
                                    },
                                    {
                                      label: "Per Week",
                                      value: 200,
                                    },
                                  ]}
                                /> */}
        </>
      );
    } else if (x.field === "paymentAmount") {
      return (
        <InputNumber
          value={rowData[x.field]}
          onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
          placeholder="0.00"
          minFractionDigits={2}
          maxFractionDigits={2}
          inputStyle={{ textAlign: "right", borderRadius: "2px" }}
        />
      );
    }
  };



  return (
    <>
      <div className="card">
        <Block17BSetupFieldsPanelHeader
          openNew={openNew}
        // selectedFieldPanelLabel={"Hello"}
        />
        <DataTable
          value={block19PaidFieldsTable}
          dataKey="id"
          key={lastAddedRowId}
          showGridlines
          className="Block19PaidTableCss"
          editMode="cell"
          resizableColumns
          columnResizeMode="expand"
          scrollable
          // reorderableColumns
          filterDisplay="menu"
          scrollHeight="516px"
        >
          {columns.map((x: any, index: any) => {
            return (
              <Column
                key={index}
                field={x.field}
                columnKey={x.field}
                style={{
                  fontSize: "0.875rem",
                }}
                body={(rowData: any, row: any) => columnsBody(rowData, row, x)}
              />
            );
          })}

          <Column
            body={(rowData: any, row: any) => {
              const showIcon = rowData.id === lastAddedRowId;
             
            
              return showIcon ? (
                <EnhancedButtonPrimeReact
                  icon="pi pi-times"
                  severity={EnhancedButtonPrimeReactSeverity.Danger}
                  className="p-button-rounded p-button-text shadow-none bg-transparent"
                  rounded
                  // onClickHandler={onDeleteNewAddedRow}
                  onClickHandler={() => onDeleteNewAddedRow(rowData.id)}
                />
              ) : null;
            }}
          />


        </DataTable>
      </div>
    </>
  );
};
